<template>
  <div class="poppins broker-shell" style="height: 100%">
    <nav-bar-broker/>
    <popup-handler/>
    <loading-page/>
    <karta-kalendar/>
    <div class="bcg-loading" v-if="loading">
      <v-progress-circular
        class="loading-spinner"
        indeterminate
      ></v-progress-circular>
    </div>
    <router-view v-else style="min-height: 100%"></router-view>
    <success-message-handler/>
  </div>
</template>

<script>
import NavBarBroker from "../components/broker/NavBarBroker";
import PopupHandler from "../components/shared/PopupHandler/PopupHandler";
import SuccessMessageHandler from "../components/shared/SuccessMessageHandler";
import LoadingPage from "../components/shared/LoadingPage";
import KartaKalendar from "../containers/broker/KartaKalendar/KartaKalendar";

export default {
  name: "Broker",
  components: {
    NavBarBroker,
    KartaKalendar,
    LoadingPage,
    SuccessMessageHandler,
    PopupHandler,
  },
  async created() {
    await this.$store.dispatch("formStore/initializeForms");
    this.loading = false;
    this.$store.dispatch("mortgageDetailCloud/initializeFileTypes");
    this.$store.dispatch("clientsEvents/updateUserEvents");
    this.$store.dispatch("clientState/retrieveEmployees", ["financnik", "alex_admin"]);
    // const viewPortWidth = window.innerWidth;
    // if (viewPortWidth > 791) return;
    // this.mobileView = true;
    // this.$store.commit("popupManagerState/pushToPopupOrder", {
    //   type: 'define',
    //   payload: null,
    //   component: "NotificationPopUp",
    //   rules: ['priority'],
    // });
  },
  data: () => ({
    loading: true,
  })
};
</script>

<style scoped>
.bcg-loading {
  position: fixed;
  background-color: rgba(0, 0, 0, 25%);
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
